"use client";

import { useState, useCallback, useEffect } from "react";

const STORAGE_KEY = "peptide-recent-searches";
const MAX_ITEMS = 5;

export function useRecentSearches() {
	const [searches, setSearches] = useState<string[]>([]);
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		queueMicrotask(() => {
			setMounted(true);
			try {
				const raw = localStorage.getItem(STORAGE_KEY);
				const parsed = raw ? (JSON.parse(raw) as string[]) : [];
				setSearches(Array.isArray(parsed) ? parsed : []);
			} catch {
				setSearches([]);
			}
		});
	}, []);

	const add = useCallback((query: string) => {
		const q = query.trim().toLowerCase();
		if (!q) return;
		setSearches((prev) => {
			const filtered = prev.filter((s) => s !== q);
			const next = [q, ...filtered].slice(0, MAX_ITEMS);
			try {
				localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
			} catch {
				// Ignore
			}
			return next;
		});
	}, []);

	const clear = useCallback(() => {
		setSearches([]);
		try {
			localStorage.removeItem(STORAGE_KEY);
		} catch {
			// Ignore
		}
	}, []);

	return { searches, add, clear, mounted };
}
